var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "ruleForm",
      staticClass: "demo-ruleForm",
      attrs: { "label-position": "top" },
    },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.RecipientName") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "receiveName",
                      "encrypted-value": _vm.ruleForm.receiveName,
                      label: _vm.$t("newOrder.RecipientName"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.RecipientCompany") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "receiveCompany",
                      "encrypted-value": _vm.ruleForm.receiveCompany,
                      label: _vm.$t("newOrder.RecipientCompany"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.Recipientphone") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "receiveMobile",
                      "encrypted-value": _vm.ruleForm.receiveMobile,
                      label: _vm.$t("newOrder.Recipientphone"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("driver.modalStreet") } },
                [_c("span", [_vm._v(_vm._s(_vm.ruleForm.receiveStreet))])]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.doorNumber") } },
                [_c("span", [_vm._v(_vm._s(_vm.ruleForm.receiveHouseNumber))])]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.RecipientDistrict") } },
                [_c("span", [_vm._v(_vm._s(_vm.ruleForm.receiveArea))])]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.RecipientCity") } },
                [_c("span", [_vm._v(_vm._s(_vm.ruleForm.receiveCity))])]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.RecipientState") } },
                [_c("span", [_vm._v(_vm._s(_vm.ruleForm.receiveState))])]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.RecipientZipCode") } },
                [_c("span", [_vm._v(_vm._s(_vm.ruleForm.receiveZipcode))])]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("GlobalSetObj.recipientComplement") },
                },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "receiveComplement",
                      "encrypted-value": _vm.ruleForm.receiveComplement,
                      label: _vm.$t("GlobalSetObj.recipientComplement"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.RecipientCPF") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "receiveTax",
                      "encrypted-value": _vm.ruleForm.receiveTax,
                      label: _vm.$t("newOrder.RecipientCPF"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("navbar.receiveIe") } },
                [_c("span", [_vm._v(_vm._s(_vm.ruleForm.receiveIeNumber))])]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.ReceivingAddress") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "receiveAddress",
                      "encrypted-value": _vm.ruleForm.receiveAddress,
                      label: _vm.$t("newOrder.ReceivingAddress"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.Recipientphonenumber") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "receivePhone",
                      "encrypted-value": _vm.ruleForm.receivePhone,
                      label: _vm.$t("newOrder.Recipientphonenumber"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.RecipientEmail") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "receiveMail",
                      "encrypted-value": _vm.ruleForm.receiveMail,
                      label: _vm.$t("newOrder.RecipientEmail"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }